import { stepValue, clampValue } from '../lib/numberStepper.js';

// Task 3 (2026-06): − / value / + integer stepper. Controlled; value is a string
// ('' = unset). Self-contained inline styles (no global CSS dependency).
const wrap = { display: 'inline-flex', alignItems: 'center', border: '1px solid #cbd5e1', borderRadius: 6, overflow: 'hidden' };
const btn = { width: 32, height: 32, border: 'none', background: '#f1f5f9', cursor: 'pointer', fontSize: 18, lineHeight: '32px', color: '#334155' };
const input = { width: 64, height: 32, border: 'none', borderLeft: '1px solid #e2e8f0', borderRight: '1px solid #e2e8f0', textAlign: 'center', fontSize: 14, MozAppearance: 'textfield' };

export function NumberStepper({ id, value, onChange, min = 0, ariaLabel }) {
  return (
    <div style={wrap} className="number-stepper">
      <button type="button" style={btn} aria-label={`${ariaLabel || ''} минус`} onClick={() => onChange(stepValue(value, -1, min))}>−</button>
      <input
        id={id}
        type="number"
        inputMode="numeric"
        step="1"
        min={min}
        style={input}
        value={value}
        aria-label={ariaLabel}
        placeholder="—"
        onChange={(e) => onChange(clampValue(e.target.value, min))}
      />
      <button type="button" style={btn} aria-label={`${ariaLabel || ''} плюс`} onClick={() => onChange(stepValue(value, +1, min))}>+</button>
    </div>
  );
}
